export interface User {
  id : number;
  createDate : string;
  updateDate : string;
  name : string;
  actionSource : string;
  actionCompany : number;
  actionTime : string;
  actionUser : number;

  customUserType : string;
  email : string;
  isLock : boolean;
  isUse : isUseType;
  lastAccessIp : string;
  lastAccessTime : number;
  lockCnt : number;
  membernum : string;
  passingCardNo : string;
  password : string;
  passwordChangeDate : number;
  permAccessIp1 : string;
  permAccessIp2 : string;
  roleType : RoleType;
  username : string;
  company : any;
  credential : any;
  dept : any;
  title : any;
  dCode : any;

}

enum RoleType {
		ROLE_USER, ROLE_ADMIN, ROLE_SECURITY_MANAGER, ROLE_SUPER_MANAGER, ROLE_VISITOR_USER, ROLE_VISITOR_ADMIN, ROLE_VISITOR_MANAGER
}

enum isUseType {
		NOT_USE, USE
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/model/user.ts